
import store from '@/store';
import {defineComponent} from 'vue';
import UserInfoDto from "@/dto/UserInfoDto";
import router from "@/router";
export default defineComponent({
  name: 'LoginView',
  created() {
    console.log('>>>>created>>>>')
    this.axios.get('/logout').then((res)=>{
      console.log(JSON.stringify(res.data))
    }).catch()
  },
  methods:{
    goExam(){
      this.$router.push('/exam')
    },
    auth(){
      //document.body.style.transform='rotateX(50deg)';
      /*
      var metalist = document.getElementsByTagName('meta');
      var target = 0;
      for(var i = 0; i < metalist.length; i++) {
        var name = metalist[i].getAttribute('name');
        if(name && name.toLowerCase() === 'viewport') {
          console.log(name)
          metalist[i].setAttribute('content', 'width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no');
          target = i;
          break;
        }
      }
      */
      //metalist[target].setAttribute('content', 'width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=2.0,user-scalable=yes');

      //document.body.style.transformOrigin = '0 0';
      //alert(window.visualViewport.scale > 1)
      //alert(JSON.stringify(document.st))

      this.axios.post('/auth',{userId: this.userId, password: this.password}).then((res)=>{
        console.log(JSON.stringify(res.data))
        if(res.data){
          console.log('認証されました')
          //this.userInfo = res.data.userInfo as UserInfoDto
          store.commit('setUserInfo', res.data)
          router.push({path:'/menu'})
        }else{
          this.userInfo = null
          console.log('認証されま戦でした')
          this.showMessage = true
          setTimeout(()=>{this.showMessage = false}, 3000);
        }
      }).catch()

    }
  },
  data(){
    return {
      tabIndex: 0,
      userId: '',
      password: '',
      showMessage: false
    }
  },
  computed:{
    /**
     * 処理中(store)
     */
    loading: {
      get(): boolean {
        return store.getters.loading
      },
      set(loading: boolean) {
        store.commit('setLoading', loading)
      }
    },
    /**
     * ユーザー情報(store)
     */
    userInfo: {
      get(): UserInfoDto|null {
        return store.getters.userInfo
      },
      set(userInfo: UserInfoDto|null) {
        store.commit('setUserInfo', userInfo)
      }
    },
  }
});
